import { gql, GraphQLClient } from 'graphql-request';
import { fetchWithRetry } from '../../helpers/retrier';
import { generateBRJWTToken } from '../../services/jwt-token';

const fetchFn = async (query, url, options) => {
  return fetchWithRetry(`fetch BR request ${query}`, url, options);
};

export default async function request(query, mutation = false, headers = {}) {
  const headersObject =
    Object.keys(headers).length === 0
      ? {}
      : {
          headers: {
            ...headers,
            'Content-Type': 'application/json',
          },
        };
  const client = new GraphQLClient(
    `${process.env.BUSINESS_REGISTRY_URL}/graphql`,
    {
      fetch: async (url, options) =>
        fetchFn(query, url, {
          ...options,
          ...(mutation
            ? {
                headers: {
                  ...headers,
                  'Content-Type': 'application/json',
                  authorization: `Bearer ${generateBRJWTToken()}`,
                },
              }
            : headersObject),
        }),
    }
  );
  return client.request(
    gql`
      ${query}
    `
  );
}
